class TabSections extends HTMLElement {
    constructor() {
      super();
      this.toggles = [...this.querySelectorAll('[data-toggle]')];
      this.collapsibles = [...document.querySelectorAll('[data-tab-content]')];
    }
  
    connectedCallback() {
      this.toggles?.forEach((btn) => {
        const id = btn.dataset.toggle;
        const collapsibles = this.collapsibles.filter(({ dataset }) => dataset.tabContent === id);
        
        btn.addEventListener('click', () => {
          this.toggles.forEach((tab)=>{
              tab.classList.remove('active');
          })
          btn.classList.add('active');
          this.titleOption?.forEach((t) => {
            t.innerHTML = btn.text;
          })
          this.collapsibles.filter(({ dataset }) => dataset.tabContent !== id)
            .forEach((inactiveCollapsible) => {
              // eslint-disable-next-line no-param-reassign
              inactiveCollapsible.classList.add('hidden');
            });
            collapsibles.forEach((collapsible) => {
                collapsible.classList.remove('hidden');
            })
        });
  
      });
      //DEEP LINK
      let url = window.location.href;
      if (url.indexOf("#") > 0){
        const activeTab = url.substring(url.indexOf("#") + 1);
  
        const activecollapsible = this.toggles.find(({ dataset }) => dataset.toggle === activeTab);
  
        if(activecollapsible){
          activecollapsible.click();
        }
      }

      this.setupLoad();

    }

    setupLoad(){
     const activeTab = this.toggles.find(({ classList }) => classList.contains('active'));
        if(activeTab){
            activeTab.click();
        }
    }

  }
  customElements.define('tab-sections', TabSections);